import styled from 'styled-components'

import { AuditLogRecordStyled } from '../../../views/AuditLogRecord/styles/AuditLogRecordStyled'

// The entries drop their list markers, and WebKit then stops exposing the `ul`
// as a list, so the role is explicit.
export const AuditLogListStyled = styled.ul.attrs({ role: 'list' })`
  /* Room for the first record's status label, which overhangs by space.small */
  padding-top: ${(props) => props.theme.space.small};

  & {
    ${AuditLogRecordStyled} + ${AuditLogRecordStyled} {
      margin-top: ${(props) => props.theme.space.large};
    }
  }
`
